(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/account-selector/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/numbergames/account-selector/assets/javascripts/prescript.js');

'use strict';

svs.numbergames = svs.numbergames || {};
svs.numbergames.accountSelector = svs.numbergames.accountSelector || {};
svs.numbergames.accountSelector._internal = svs.numbergames.accountSelector._internal || {};

 })(window);